import { WebSocketProvider, WebSocketConfig, WebSocketProviderType } from './types';
import { SocketIOProvider } from './SocketIOProvider';
import { NativeWSProvider } from './NativeWSProvider';

export class WebSocketFactory {
  /**
   * Create a WebSocket provider based on the specified type
   * @param type - The type of WebSocket provider ('socket.io' or 'native')
   * @param config - Configuration for the WebSocket connection
   * @returns An instance of the appropriate WebSocket provider
   */
  static createProvider(
    type: WebSocketProviderType,
    config: WebSocketConfig
  ): WebSocketProvider {
    switch (type) {
      case 'socket.io':
        return new SocketIOProvider(config);
      case 'native':
        return new NativeWSProvider(config);
      default:
        throw new Error(`Unknown WebSocket provider type: ${type}`);
    }
  }

  /**
   * Automatically determine which provider to use based on environment or configuration
   * Can be extended with more sophisticated logic
   */
  static createAutoProvider(config: WebSocketConfig): WebSocketProvider {
    // You can add logic here to determine which provider to use
    // For example, check environment variables, feature flags, etc.
    const providerType = this.getProviderType();
    return this.createProvider(providerType, config);
  }

  private static getProviderType(): WebSocketProviderType {
    // Check environment variable or configuration
    // For now, return a default or check localStorage/sessionStorage
    const storedType = localStorage.getItem('ws_provider_type') as WebSocketProviderType;
    
    if (storedType === 'native' || storedType === 'socket.io') {
      return storedType;
    }

    // Default to socket.io for backward compatibility
    return 'socket.io';
  }

  /**
   * Set the preferred WebSocket provider type
   */
  static setProviderType(type: WebSocketProviderType): void {
    localStorage.setItem('ws_provider_type', type);
  }
}
